<template>
  <div class="dw-website-home">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="container">
        <div class="logo">
          <h1>大为尚视（北京）网络科技有限公司</h1>
        </div>
        <nav class="nav">
          <ul>
            <li><a href="#services">服务项目</a></li>
            <li><a href="#about">关于我们</a></li>
            <!-- <li><a href="#cases">成功案例</a></li> -->
            <li><a href="#process">开发流程</a></li>
            <li><a href="#contact">联系我们</a></li>
          </ul>
        </nav>
        <div class="mobile-menu-toggle">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>

    <!-- Banner区域 -->
    <section class="hero-banner">
      <div class="banner-content">
        <h2>专业的网站开发解决方案</h2>
        <p>为企业提供全方位、定制化的网站开发服务，助力数字化转型</p>
        <div class="cta-buttons">
          <a href="#contact" class="btn-primary">立即咨询</a>
          <!-- <a href="#cases" class="btn-secondary">查看案例</a> -->
        </div>
      </div>
    </section>

    <!-- 服务项目 -->
    <section id="services" class="services-section">
      <div class="container">
        <div class="section-header">
          <h3>我们的服务</h3>
          <div class="section-divider"></div>
          <p>提供全方位的网站开发与数字化解决方案</p>
        </div>
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon">
              <div class="icon-box">PC</div>
            </div>
            <h4>企业官网开发</h4>
            <p>专业的企业形象展示网站，突出品牌价值，提升企业形象</p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <div class="icon-box">EC</div>
            </div>
            <h4>电商平台开发</h4>
            <p>功能完善的在线商城系统，支持多种支付方式，助力线上销售</p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <div class="icon-box">RWD</div>
            </div>
            <h4>响应式网站</h4>
            <p>自适应各种设备屏幕，提供一致的用户体验</p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <div class="icon-box">CMS</div>
            </div>
            <h4>内容管理系统</h4>
            <p>易于管理和更新的后台系统，让您轻松维护网站内容</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 关于我们 -->
    <section id="about" class="about-section">
      <div class="container">
        <div class="about-content">
          <div class="about-text">
            <div class="section-header">
              <h3>关于我们</h3>
              <div class="section-divider"></div>
            </div>
            <p>大为尚视（北京）网络科技有限公司成立于2020年01月10日，注册地位于北京市海淀区上地五街16号1幢2层212室。</p>
            <p>公司专注于技术开发、技术咨询、技术交流、技术转让、技术推广、技术服务；软件开发；软件咨询；市场调查；企业管理咨询；经济贸易咨询；企业策划、设计；设计、制作、代理、发布广告等全方位互联网服务。</p>
            <div class="stats">
              <div class="stat-item">
                <span class="stat-number">50+</span>
                <span class="stat-label">成功项目</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">30+</span>
                <span class="stat-label">合作客户</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">3年</span>
                <span class="stat-label">行业经验</span>
              </div>
            </div>
          </div>
          <div class="about-image">
            <div class="image-placeholder">
              <!-- <span>公司环境/团队照片</span> -->
               <img src="/imgs/us.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 成功案例 -->
    <section id="cases" class="cases-section" style="display: none;">
      <div class="container">
        <div class="section-header">
          <h3>成功案例</h3>
          <div class="section-divider"></div>
          <p>我们为各行各业的企业提供了专业的网站解决方案</p>
        </div>
        <div class="cases-grid">
          <div class="case-card">
            <div class="case-image">
              <div class="image-placeholder">
                <span>案例1</span>
              </div>
            </div>
            <div class="case-content">
              <h4>教育行业官网</h4>
              <p>为知名教育机构打造的品牌官网，提升品牌形象和招生转化率</p>
              <a href="#" class="case-link">查看详情 ></a>
            </div>
          </div>
          <div class="case-card">
            <div class="case-image">
              <div class="image-placeholder">
                <span>案例2</span>
              </div>
            </div>
            <div class="case-content">
              <h4>电商平台</h4>
              <p>多功能电商平台开发，集成支付、物流和会员管理系统</p>
              <a href="#" class="case-link">查看详情 ></a>
            </div>
          </div>
          <div class="case-card">
            <div class="case-image">
              <div class="image-placeholder">
                <span>案例3</span>
              </div>
            </div>
            <div class="case-content">
              <h4>企业响应式网站</h4>
              <p>跨平台适配的企业官网，提供一致的用户体验</p>
              <a href="#" class="case-link">查看详情 ></a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 开发流程 -->
    <section id="process" class="process-section">
      <div class="container">
        <div class="section-header">
          <h3>开发流程</h3>
          <div class="section-divider"></div>
          <p>科学严谨的开发流程，确保项目质量和进度</p>
        </div>
        <div class="process-steps">
          <div class="process-step">
            <div class="step-number">1</div>
            <h4>需求分析</h4>
            <p>深入了解客户需求，明确项目目标和功能要求</p>
          </div>
          <div class="process-step">
            <div class="step-number">2</div>
            <h4>方案设计</h4>
            <p>制定详细的技术方案和UI/UX设计，确认项目蓝图</p>
          </div>
          <div class="process-step">
            <div class="step-number">3</div>
            <h4>开发实现</h4>
            <p>按照设计方案进行编码开发，实现各项功能</p>
          </div>
          <div class="process-step">
            <div class="step-number">4</div>
            <h4>测试上线</h4>
            <p>全面测试确保质量，部署上线并提供后续支持</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="contact-section">
      <div class="container">
        <div class="section-header">
          <h3>联系我们</h3>
          <div class="section-divider"></div>
          <p>欢迎随时与我们联系，获取专业的网站开发咨询服务</p>
        </div>
        <div class="contact-content">
          <div class="contact-info">
            <h4>大为尚视（北京）网络科技有限公司</h4>
            <div class="contact-item">
              <div class="contact-icon">
                <div class="icon-box">T</div>
              </div>
              <div class="contact-text">
                <p>联系电话：57185873</p>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">
                <div class="icon-box">E</div>
              </div>
              <div class="contact-text">
                <p>联系邮箱：1919812860@qq.com</p>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">
                <div class="icon-box">W</div>
              </div>
              <div class="contact-text">
                <p>网站域名：doramusic.cn</p>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">
                <div class="icon-box">A</div>
              </div>
              <div class="contact-text">
                <p>公司地址：北京市海淀区上地五街16号1幢2层212室</p>
              </div>
            </div>
          </div>
          <div class="contact-form">
            <h4>在线咨询</h4>
            <form>
              <div class="form-group">
                <input type="text" placeholder="您的姓名" required>
              </div>
              <div class="form-group">
                <input type="tel" placeholder="联系电话" required>
              </div>
              <div class="form-group">
                <textarea placeholder="项目需求描述" rows="4"></textarea>
              </div>
              <button type="button" class="btn-primary">提交咨询</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <h3>大为尚视（北京）网络科技有限公司</h3>
            <p>专业的网站开发与数字化解决方案提供商</p>
          </div>
          <div class="footer-links">
            <h4>快速链接</h4>
            <ul>
              <li><a href="#services">服务项目</a></li>
              <li><a href="#about">关于我们</a></li>
              <!-- <li><a href="#cases">成功案例</a></li> -->
              <li><a href="#contact">联系我们</a></li>
            </ul>
          </div>
          <div class="footer-contact">
            <h4>联系我们</h4>
            <p>电话：57185873</p>
            <p>邮箱：1919812860@qq.com</p>
            <p>地址：北京市海淀区上地五街16号1幢2层212室</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; 2025 大为尚视（北京）网络科技有限公司 版权所有 -- 
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">ICP备案：京ICP备20021053号-1</a>
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "dwWebsiteHome",
  data() {
    return {};
  },
  mounted() {
    document.title = "大为尚视（北京）网络科技有限公司";
    this.initMobileMenu();
  },
  methods: {
    initMobileMenu() {
      const toggle = document.querySelector('.mobile-menu-toggle');
      const nav = document.querySelector('.nav');

      if (toggle) {
        toggle.addEventListener('click', () => {
          nav.classList.toggle('active');
          toggle.classList.toggle('active');
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
// 变量定义
$primary-color: #2563eb;
$secondary-color: #1e40af;
$accent-color: #3b82f6;
$text-color: #333;
$light-text: #666;
$background-light: #f8fafc;
$border-color: #e2e8f0;
$white: #fff;
$shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

// 混合宏
@mixin flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

@mixin container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

@mixin section-padding {
  padding: 80px 0;
}

@mixin card-style {
  background: $white;
  border-radius: 8px;
  box-shadow: $shadow;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

// 响应式断点
$tablet: 768px;
$mobile: 480px;

// 全局样式 - 修复移动端宽度问题
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.dw-website-home {
  font-family: 'Arial', 'Helvetica', sans-serif;
  color: $text-color;
  line-height: 1.6;
  width: 100%;
  overflow-x: hidden; // 防止横向滚动
}

.container {
  @include container;
}

// 头部导航
.header {
  background: $white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
  }

  .logo h1 {
    color: $primary-color;
    font-size: 18px;
    font-weight: 700;
    white-space: nowrap;
  }

  .nav ul {
    display: flex;
    list-style: none;

    li {
      margin-left: 30px;

      a {
        text-decoration: none;
        color: $text-color;
        font-weight: 500;
        transition: color 0.3s;
        white-space: nowrap;

        &:hover {
          color: $primary-color;
        }
      }
    }
  }

  .mobile-menu-toggle {
    display: none;
    flex-direction: column;
    cursor: pointer;

    span {
      width: 25px;
      height: 3px;
      background: $text-color;
      margin: 3px 0;
      transition: 0.3s;
    }
  }
}

// Banner区域
.hero-banner {
  background: linear-gradient(135deg, $primary-color, $secondary-color);
  color: $white;
  height: 600px;
  @include flex-center;
  text-align: center;
  margin-top: 70px;
  width: 100%;

  .banner-content {
    max-width: 800px;
    padding: 0 20px;
    width: 100%;

    h2 {
      font-size: 48px;
      margin-bottom: 20px;
      font-weight: 700;
    }

    p {
      font-size: 20px;
      margin-bottom: 40px;
      opacity: 0.9;
    }

    .cta-buttons {
      display: flex;
      justify-content: center;
      gap: 20px;

      a {
        padding: 12px 30px;
        border-radius: 5px;
        text-decoration: none;
        font-weight: 600;
        transition: all 0.3s;
        white-space: nowrap;
      }

      .btn-primary {
        background: $white;
        color: $primary-color;

        &:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        }
      }

      .btn-secondary {
        border: 2px solid $white;
        color: $white;

        &:hover {
          background: $white;
          color: $primary-color;
        }
      }
    }
  }
}

// 通用区块样式
.section-header {
  text-align: center;
  margin-bottom: 60px;
  width: 100%;

  h3 {
    font-size: 36px;
    margin-bottom: 15px;
    color: $text-color;
  }

  .section-divider {
    width: 80px;
    height: 3px;
    background: $primary-color;
    margin: 0 auto 20px;
  }

  p {
    color: $light-text;
    font-size: 18px;
    max-width: 600px;
    margin: 0 auto;
  }
}

// 服务项目
.services-section {
  @include section-padding;
  background: $background-light;
  width: 100%;

  .services-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;
    width: 100%;
  }

  .service-card {
    @include card-style;
    padding: 30px;
    text-align: center;
    width: 100%;

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
    }

    .service-icon {
      margin-bottom: 20px;

      .icon-box {
        width: 70px;
        height: 70px;
        background: $primary-color;
        color: $white;
        border-radius: 50%;
        @include flex-center;
        margin: 0 auto;
        font-size: 24px;
        font-weight: bold;
      }
    }

    h4 {
      font-size: 22px;
      margin-bottom: 15px;
      color: $text-color;
    }

    p {
      color: $light-text;
      line-height: 1.6;
    }
  }
}

// 关于我们
.about-section {
  @include section-padding;
  width: 100%;

  .about-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
    align-items: center;
    width: 100%;

    .about-text {
      .section-header {
        text-align: left;

        .section-divider {
          margin-left: 0;
        }
      }

      p {
        margin-bottom: 20px;
        color: $light-text;
        line-height: 1.8;
      }

      .stats {
        display: flex;
        margin-top: 30px;
        width: 100%;

        .stat-item {
          text-align: center;
          margin-right: 40px;

          .stat-number {
            display: block;
            font-size: 36px;
            font-weight: 700;
            color: $primary-color;
          }

          .stat-label {
            color: $light-text;
            font-size: 14px;
          }
        }
      }
    }

    .about-image {
      .image-placeholder {
        height: 400px;
        background: #e2e8f0;
        border-radius: 8px;
        @include flex-center;
        color: $light-text;
        font-size: 18px;
        width: 100%;
      }
    }
  }
}

// 成功案例
.cases-section {
  @include section-padding;
  background: $background-light;
  width: 100%;

  .cases-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 30px;
    width: 100%;
  }

  .case-card {
    @include card-style;
    width: 100%;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    }

    .case-image {
      height: 200px;
      width: 100%;

      .image-placeholder {
        height: 100%;
        background: #e2e8f0;
        @include flex-center;
        color: $light-text;
        width: 100%;
      }
    }

    .case-content {
      padding: 25px;
      width: 100%;

      h4 {
        font-size: 20px;
        margin-bottom: 10px;
        color: $text-color;
      }

      p {
        color: $light-text;
        margin-bottom: 15px;
        line-height: 1.6;
      }

      .case-link {
        color: $primary-color;
        text-decoration: none;
        font-weight: 600;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

// 开发流程
.process-section {
  @include section-padding;
  width: 100%;

  .process-steps {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 30px;
    width: 100%;
  }

  .process-step {
    text-align: center;
    padding: 30px 20px;
    width: 100%;

    .step-number {
      width: 60px;
      height: 60px;
      background: $primary-color;
      color: $white;
      border-radius: 50%;
      @include flex-center;
      font-size: 24px;
      font-weight: 700;
      margin: 0 auto 20px;
    }

    h4 {
      font-size: 20px;
      margin-bottom: 15px;
      color: $text-color;
    }

    p {
      color: $light-text;
      line-height: 1.6;
    }
  }
}

// 联系我们
.contact-section {
  @include section-padding;
  background: $background-light;
  width: 100%;

  .contact-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
    width: 100%;
  }

  .contact-info {
    h4 {
      font-size: 24px;
      margin-bottom: 30px;
      color: $text-color;
    }

    .contact-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 25px;
      width: 100%;

      .contact-icon {
        margin-right: 15px;

        .icon-box {
          width: 40px;
          height: 40px;
          background: $primary-color;
          color: $white;
          border-radius: 50%;
          @include flex-center;
          font-weight: bold;
          flex-shrink: 0;
        }
      }

      .contact-text {
        width: 100%;
        
        p {
          color: $light-text;
          line-height: 1.6;
          word-break: break-word;
        }
      }
    }
  }

  .contact-form {
    background: $white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: $shadow;
    width: 100%;

    h4 {
      font-size: 24px;
      margin-bottom: 25px;
      color: $text-color;
    }

    .form-group {
      margin-bottom: 20px;
      width: 100%;

      input,
      textarea {
        width: 100%;
        padding: 12px 15px;
        border: 1px solid $border-color;
        border-radius: 5px;
        font-size: 16px;
        transition: border-color 0.3s;

        &:focus {
          outline: none;
          border-color: $primary-color;
        }
      }

      textarea {
        resize: vertical;
        min-height: 120px;
      }
    }

    .btn-primary {
      background: $primary-color;
      color: $white;
      border: none;
      padding: 12px 30px;
      border-radius: 5px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: background 0.3s;
      width: 100%;

      &:hover {
        background: $secondary-color;
      }
    }
  }
}

// 页脚
.footer {
  background: #1e293b;
  color: $white;
  padding: 60px 0 20px;
  width: 100%;

  .footer-content {
    display: grid;
    grid-template-columns: 2fr 1fr 1.5fr;
    gap: 40px;
    margin-bottom: 40px;
    width: 100%;

    h3,
    h4 {
      margin-bottom: 20px;
      color: $white;
    }

    p,
    a {
      color: #cbd5e1;
      line-height: 1.8;
    }

    .footer-links ul {
      list-style: none;

      li {
        margin-bottom: 10px;

        a {
          text-decoration: none;
          transition: color 0.3s;

          &:hover {
            color: $white;
          }
        }
      }
    }
  }

  .footer-bottom {
    border-top: 1px solid #334155;
    padding-top: 20px;
    text-align: center;
    color: #94a3b8;
    font-size: 14px;
    
    a {
      color: #94a3b8;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

// 响应式设计 - 修复移动端问题
@media (max-width: $tablet) {
  .header {
    .nav {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: $white;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
      transition: 0.3s;
      width: 100%;

      &.active {
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
      }

      ul {
        flex-direction: column;
        padding: 20px;
        width: 100%;

        li {
          margin: 0 0 15px 0;
          width: 100%;

          a {
            display: block;
            padding: 10px 0;
            width: 100%;
          }
        }
      }
    }

    .mobile-menu-toggle {
      display: flex;

      &.active span:nth-child(1) {
        transform: rotate(-45deg) translate(-5px, 6px);
      }

      &.active span:nth-child(2) {
        opacity: 0;
      }

      &.active span:nth-child(3) {
        transform: rotate(45deg) translate(-5px, -6px);
      }
    }
  }

  .container {
    padding: 0 15px; // 移动端减少内边距
  }

  .hero-banner {
    height: 500px;
    margin-top: 60px;

    .banner-content {
      h2 {
        font-size: 36px;
      }

      p {
        font-size: 18px;
      }

      .cta-buttons {
        flex-direction: column;
        align-items: center;
        gap: 15px;

        a {
          width: 200px;
          text-align: center;
        }
      }
    }
  }

  .about-content,
  .contact-content {
    grid-template-columns: 1fr !important;
    gap: 30px !important;
  }

  .footer-content {
    grid-template-columns: 1fr !important;
    gap: 30px !important;
  }

  .stats {
    justify-content: space-between;
    flex-wrap: wrap;

    .stat-item {
      margin-right: 0 !important;
      flex: 1;
      min-width: 100px;
      margin-bottom: 20px;
    }
  }
  
  .section-header {
    margin-bottom: 40px;
    
    h3 {
      font-size: 32px;
    }
  }
}

@media (max-width: $mobile) {
  .hero-banner {
    height: 400px;
    margin-top: 60px;

    .banner-content {
      h2 {
        font-size: 28px;
        line-height: 1.3;
      }

      p {
        font-size: 16px;
        line-height: 1.5;
      }
    }
  }

  .section-header h3 {
    font-size: 28px;
  }

  .services-grid,
  .cases-grid,
  .process-steps {
    grid-template-columns: 1fr !important;
    gap: 20px;
  }
  
  .service-card,
  .case-card,
  .process-step {
    padding: 20px 15px;
  }
  
  .about-section,
  .services-section,
  .process-section,
  .contact-section {
    padding: 60px 0;
  }
  
  .about-image .image-placeholder {
    height: 300px !important;
  }
  
  .contact-form {
    padding: 20px !important;
  }
  
  .footer {
    padding: 40px 0 20px;
    
    .footer-content {
      gap: 25px;
      margin-bottom: 30px;
    }
  }
  
  // 修复统计数字在极小屏幕上的显示
  .stats {
    .stat-item {
      min-width: 80px;
      
      .stat-number {
        font-size: 28px !important;
      }
      
      .stat-label {
        font-size: 12px !important;
      }
    }
  }
}

// 超小屏幕设备优化
@media (max-width: 360px) {
  .container {
    padding: 0 10px;
  }
  
  .hero-banner .banner-content h2 {
    font-size: 24px;
  }
  
  .section-header h3 {
    font-size: 24px;
  }
  
  .service-card h4,
  .case-content h4,
  .process-step h4 {
    font-size: 18px;
  }
  
  .footer-bottom {
    font-size: 12px;
  }
}
</style>